// extracted by mini-css-extract-plugin
export var menu__item = "NavigationMenuItem-module--menu__item--1HhnF";
export var menu__anchor = "NavigationMenuItem-module--menu__anchor--1Wk9u";
export var menu__anchorActive = "NavigationMenuItem-module--menu__anchor--active--1r36o";